/**
 * Name: beam
 * Version: 1.2.4
 * Generated: 2018-05-04
 */

var _Beam = (function() {
    'use strict';
    var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
    function createCommonjsModule(fn, module) {
        return (
            (module = {
                exports: {}
            }),
            fn(module, module.exports),
            module.exports
        );
    }
    var _typeof =
        typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol'
            ? function(obj) {
                    return typeof obj;
              }
            : function(obj) {
                    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
              };
    var slicedToArray = (function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally {
                try {
                    if (!_n && _i['return']) _i['return']();
                } finally {
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) {
                return arr;
            } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            } else {
                throw new TypeError('Invalid attempt to destructure non-iterable instance');
            }
        };
    })();
    var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var _freeGlobal = freeGlobal;
    var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;
    var root = _freeGlobal || freeSelf || Function('return this')();
    var _root = root;
    var _Symbol2 = _root.Symbol;
    var _Symbol = _Symbol2;
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
    function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];
        try {
            value[symToStringTag] = undefined;
            var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString.call(value);
        if (unmasked) {
            if (isOwn) {
                value[symToStringTag] = tag;
            } else {
                delete value[symToStringTag];
            }
        }
        return result;
    }
    var _getRawTag = getRawTag;
    var objectProto$1 = Object.prototype;
    var nativeObjectToString$1 = objectProto$1.toString;
    function objectToString(value) {
        return nativeObjectToString$1.call(value);
    }
    var _objectToString = objectToString;
    var nullTag = '[object Null]',
        undefinedTag = '[object Undefined]';
    var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
    function baseGetTag(value) {
        if (value == null) {
            return value === undefined ? undefinedTag : nullTag;
        }
        return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
    }
    var _baseGetTag = baseGetTag;
    function isObject(value) {
        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
        return value != null && (type == 'object' || type == 'function');
    }
    var isObject_1 = isObject;
    var asyncTag = '[object AsyncFunction]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        proxyTag = '[object Proxy]';
    function isFunction(value) {
        if (!isObject_1(value)) {
            return false;
        }
        var tag = _baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    var isFunction_1 = isFunction;
    function arrayMap(array, iteratee) {
        var index = -1,
            length = array == null ? 0 : array.length,
            result = Array(length);
        while (++index < length) {
            result[index] = iteratee(array[index], index, array);
        }
        return result;
    }
    var _arrayMap = arrayMap;
    var isArray = Array.isArray;
    var isArray_1 = isArray;
    function isObjectLike(value) {
        return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
    }
    var isObjectLike_1 = isObjectLike;
    var symbolTag = '[object Symbol]';
    function isSymbol(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
    }
    var isSymbol_1 = isSymbol;
    var INFINITY = 1 / 0;
    var symbolProto = _Symbol ? _Symbol.prototype : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;
    function baseToString(value) {
        if (typeof value == 'string') {
            return value;
        }
        if (isArray_1(value)) {
            return _arrayMap(value, baseToString) + '';
        }
        if (isSymbol_1(value)) {
            return symbolToString ? symbolToString.call(value) : '';
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
    }
    var _baseToString = baseToString;
    function toString(value) {
        return value == null ? '' : _baseToString(value);
    }
    var toString_1 = toString;
    function baseSlice(array, start, end) {
        var index = -1,
            length = array.length;
        if (start < 0) {
            start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
            end += length;
        }
        length = start > end ? 0 : (end - start) >>> 0;
        start >>>= 0;
        var result = Array(length);
        while (++index < length) {
            result[index] = array[index + start];
        }
        return result;
    }
    var _baseSlice = baseSlice;
    function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined ? length : end;
        return !start && end >= length ? array : _baseSlice(array, start, end);
    }
    var _castSlice = castSlice;
    var rsAstralRange = '\\ud800-\\udfff',
        rsComboMarksRange = '\\u0300-\\u036f',
        reComboHalfMarksRange = '\\ufe20-\\ufe2f',
        rsComboSymbolsRange = '\\u20d0-\\u20ff',
        rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
        rsVarRange = '\\ufe0e\\ufe0f';
    var rsZWJ = '\\u200d';
    var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    var _hasUnicode = hasUnicode;
    function asciiToArray(string) {
        return string.split('');
    }
    var _asciiToArray = asciiToArray;
    var rsAstralRange$1 = '\\ud800-\\udfff',
        rsComboMarksRange$1 = '\\u0300-\\u036f',
        reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
        rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
        rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
        rsVarRange$1 = '\\ufe0e\\ufe0f';
    var rsAstral = '[' + rsAstralRange$1 + ']',
        rsCombo = '[' + rsComboRange$1 + ']',
        rsFitz = '\\ud83c[\\udffb-\\udfff]',
        rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
        rsNonAstral = '[^' + rsAstralRange$1 + ']',
        rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
        rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
        rsZWJ$1 = '\\u200d';
    var reOptMod = rsModifier + '?',
        rsOptVar = '[' + rsVarRange$1 + ']?',
        rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
        rsSeq = rsOptVar + reOptMod + rsOptJoin,
        rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
    var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    var _unicodeToArray = unicodeToArray;
    function stringToArray(string) {
        return _hasUnicode(string) ? _unicodeToArray(string) : _asciiToArray(string);
    }
    var _stringToArray = stringToArray;
    function createCaseFirst(methodName) {
        return function(string) {
            string = toString_1(string);
            var strSymbols = _hasUnicode(string) ? _stringToArray(string) : undefined;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? _castSlice(strSymbols, 1).join('') : string.slice(1);
            return chr[methodName]() + trailing;
        };
    }
    var _createCaseFirst = createCaseFirst;
    var upperFirst = _createCaseFirst('toUpperCase');
    var upperFirst_1 = upperFirst;
    function capitalize(string) {
        return upperFirst_1(toString_1(string).toLowerCase());
    }
    var capitalize_1 = capitalize;
    (function() {
        if (typeof window.CustomEvent === 'function') return false;
        function CustomEvent(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    })();
    (function() {
        if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (!Element.prototype.closest)
            Element.prototype.closest = function(s) {
                var el = this;
                if (!document.documentElement.contains(el)) return null;
                do {
                    if (el.matches(s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);
                return null;
            };
    })();
    if (!Function.prototype.bind) {
        Function.prototype.bind = function(oThis) {
            if (typeof this !== 'function') {
                throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
            }
            var aArgs = Array.prototype.slice.call(arguments, 1),
                fToBind = this,
                FNOP = function FNOP() {},
                fBound = function fBound() {
                    return fToBind.apply(this instanceof FNOP && oThis ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
                };
            FNOP.prototype = this.prototype;
            fBound.prototype = new FNOP();
            return fBound;
        };
    }
    (function() {
        var ObjectProto = Object.prototype,
            defineGetter = ObjectProto.__defineGetter__,
            defineSetter = ObjectProto.__defineSetter__,
            lookupGetter = ObjectProto.__lookupGetter__,
            lookupSetter = ObjectProto.__lookupSetter__,
            hasOwnProp = ObjectProto.hasOwnProperty;
        if (defineGetter && defineSetter && lookupGetter && lookupSetter) {
            if (!Object.defineProperty) {
                Object.defineProperty = function(obj, prop, descriptor) {
                    if (arguments.length < 3) {
                        throw new TypeError('Arguments not optional');
                    }
                    prop += '';
                    if (hasOwnProp.call(descriptor, 'value')) {
                        if (!lookupGetter.call(obj, prop) && !lookupSetter.call(obj, prop)) {
                            obj[prop] = descriptor.value;
                        }
                        if (hasOwnProp.call(descriptor, 'get') || hasOwnProp.call(descriptor, 'set')) {
                            throw new TypeError('Cannot specify an accessor and a value');
                        }
                    }
                    if (!(descriptor.writable && descriptor.enumerable && descriptor.configurable)) {
                        throw new TypeError('This implementation of Object.defineProperty does not support' + ' false for configurable, enumerable, or writable.');
                    }
                    if (descriptor.get) {
                        defineGetter.call(obj, prop, descriptor.get);
                    }
                    if (descriptor.set) {
                        defineSetter.call(obj, prop, descriptor.set);
                    }
                    return obj;
                };
            }
            if (!Object.getOwnPropertyDescriptor) {
                Object.getOwnPropertyDescriptor = function(obj, prop) {
                    if (arguments.length < 2) {
                        throw new TypeError('Arguments not optional.');
                    }
                    prop += '';
                    var descriptor = {
                            configurable: true,
                            enumerable: true,
                            writable: true
                        },
                        getter = lookupGetter.call(obj, prop),
                        setter = lookupSetter.call(obj, prop);
                    if (!hasOwnProp.call(obj, prop)) {
                        return descriptor;
                    }
                    if (!getter && !setter) {
                        descriptor.value = obj[prop];
                        return descriptor;
                    }
                    delete descriptor.writable;
                    descriptor.get = descriptor.set = undefined;
                    if (getter) {
                        descriptor.get = getter;
                    }
                    if (setter) {
                        descriptor.set = setter;
                    }
                    return descriptor;
                };
            }
            if (!Object.defineProperties) {
                Object.defineProperties = function(obj, props) {
                    var prop;
                    for (prop in props) {
                        if (hasOwnProp.call(props, prop)) {
                            Object.defineProperty(obj, prop, props[prop]);
                        }
                    }
                };
            }
        }
    })();
    if (!document.documentElement.dataset && (!Object.getOwnPropertyDescriptor(Element.prototype, 'dataset') || !Object.getOwnPropertyDescriptor(Element.prototype, 'dataset').get)) {
        var propDescriptor = {
            enumerable: true,
            get: function get() {
                var i,
                    that = this,
                    HTML5_DOMStringMap,
                    attrVal,
                    attrName,
                    propName,
                    attribute,
                    attributes = this.attributes,
                    attsLength = attributes.length,
                    toUpperCase = function toUpperCase(n0) {
                        return n0.charAt(1).toUpperCase();
                    },
                    getter = function getter() {
                        return this;
                    },
                    setter = function setter(attrName, value) {
                        return typeof value !== 'undefined' ? this.setAttribute(attrName, value) : this.removeAttribute(attrName);
                    };
                try {
                    ({}.__defineGetter__('test', function() {}));
                    HTML5_DOMStringMap = {};
                } catch (e1) {
                    HTML5_DOMStringMap = document.createElement('div');
                }
                for (i = 0; i < attsLength; i++) {
                    attribute = attributes[i];
                    if (attribute && attribute.name && /^data-\w[\w\-]*$/.test(attribute.name)) {
                        attrVal = attribute.value;
                        attrName = attribute.name;
                        propName = attrName.substr(5).replace(/-./g, toUpperCase);
                        try {
                            Object.defineProperty(HTML5_DOMStringMap, propName, {
                                enumerable: this.enumerable,
                                get: getter.bind(attrVal || ''),
                                set: setter.bind(that, attrName)
                            });
                        } catch (e2) {
                            HTML5_DOMStringMap[propName] = attrVal;
                        }
                    }
                }
                return HTML5_DOMStringMap;
            }
        };
        try {
            Object.defineProperty(Element.prototype, 'dataset', propDescriptor);
        } catch (e) {
            propDescriptor.enumerable = false;
            Object.defineProperty(Element.prototype, 'dataset', propDescriptor);
        }
    }
    (function() {
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function(s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1;
                };
        }
    })();
    (function(window, document) {
        if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
            if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
                Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
                    get: function get() {
                        return this.intersectionRatio > 0;
                    }
                });
            }
            return;
        }
        function IntersectionObserverEntry(entry) {
            this.time = entry.time;
            this.target = entry.target;
            this.rootBounds = entry.rootBounds;
            this.boundingClientRect = entry.boundingClientRect;
            this.intersectionRect = entry.intersectionRect || getEmptyRect();
            this.isIntersecting = !!entry.intersectionRect;
            var targetRect = this.boundingClientRect;
            var targetArea = targetRect.width * targetRect.height;
            var intersectionRect = this.intersectionRect;
            var intersectionArea = intersectionRect.width * intersectionRect.height;
            if (targetArea) {
                this.intersectionRatio = intersectionArea / targetArea;
            } else {
                this.intersectionRatio = this.isIntersecting ? 1 : 0;
            }
        }
        function IntersectionObserver(callback, opt_options) {
            var options = opt_options || {};
            if (typeof callback != 'function') {
                throw new Error('callback must be a function');
            }
            if (options.root && options.root.nodeType != 1) {
                throw new Error('root must be an Element');
            }
            this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
            this._callback = callback;
            this._observationTargets = [];
            this._queuedEntries = [];
            this._rootMarginValues = this._parseRootMargin(options.rootMargin);
            this.thresholds = this._initThresholds(options.threshold);
            this.root = options.root || null;
            this.rootMargin = this._rootMarginValues
                .map(function(margin) {
                    return margin.value + margin.unit;
                })
                .join(' ');
        }
        IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
        IntersectionObserver.prototype.POLL_INTERVAL = null;
        IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
        IntersectionObserver.prototype.observe = function(target) {
            var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
                return item.element == target;
            });
            if (isTargetAlreadyObserved) {
                return;
            }
            if (!(target && target.nodeType == 1)) {
                throw new Error('target must be an Element');
            }
            this._registerInstance();
            this._observationTargets.push({
                element: target,
                entry: null
            });
            this._monitorIntersections();
            this._checkForIntersections();
        };
        IntersectionObserver.prototype.unobserve = function(target) {
            this._observationTargets = this._observationTargets.filter(function(item) {
                return item.element != target;
            });
            if (!this._observationTargets.length) {
                this._unmonitorIntersections();
                this._unregisterInstance();
            }
        };
        IntersectionObserver.prototype.disconnect = function() {
            this._observationTargets = [];
            this._unmonitorIntersections();
            this._unregisterInstance();
        };
        IntersectionObserver.prototype.takeRecords = function() {
            var records = this._queuedEntries.slice();
            this._queuedEntries = [];
            return records;
        };
        IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
            var threshold = opt_threshold || [0];
            if (!Array.isArray(threshold)) threshold = [threshold];
            return threshold.sort().filter(function(t, i, a) {
                if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
                    throw new Error('threshold must be a number between 0 and 1 inclusively');
                }
                return t !== a[i - 1];
            });
        };
        IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
            var marginString = opt_rootMargin || '0px';
            var margins = marginString.split(/\s+/).map(function(margin) {
                var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
                if (!parts) {
                    throw new Error('rootMargin must be specified in pixels or percent');
                }
                return {
                    value: parseFloat(parts[1]),
                    unit: parts[2]
                };
            });
            margins[1] = margins[1] || margins[0];
            margins[2] = margins[2] || margins[0];
            margins[3] = margins[3] || margins[1];
            return margins;
        };
        IntersectionObserver.prototype._monitorIntersections = function() {
            if (!this._monitoringIntersections) {
                this._monitoringIntersections = true;
                if (this.POLL_INTERVAL) {
                    this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
                } else {
                    addEvent(window, 'resize', this._checkForIntersections, true);
                    addEvent(document, 'scroll', this._checkForIntersections, true);
                    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
                        this._domObserver = new MutationObserver(this._checkForIntersections);
                        this._domObserver.observe(document, {
                            attributes: true,
                            childList: true,
                            characterData: true,
                            subtree: true
                        });
                    }
                }
            }
        };
        IntersectionObserver.prototype._unmonitorIntersections = function() {
            if (this._monitoringIntersections) {
                this._monitoringIntersections = false;
                clearInterval(this._monitoringInterval);
                this._monitoringInterval = null;
                removeEvent(window, 'resize', this._checkForIntersections, true);
                removeEvent(document, 'scroll', this._checkForIntersections, true);
                if (this._domObserver) {
                    this._domObserver.disconnect();
                    this._domObserver = null;
                }
            }
        };
        IntersectionObserver.prototype._checkForIntersections = function() {
            var rootIsInDom = this._rootIsInDom();
            var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
            this._observationTargets.forEach(function(item) {
                var target = item.element;
                var targetRect = getBoundingClientRect(target);
                var rootContainsTarget = this._rootContainsTarget(target);
                var oldEntry = item.entry;
                var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);
                var newEntry = (item.entry = new IntersectionObserverEntry({
                    time: now(),
                    target: target,
                    boundingClientRect: targetRect,
                    rootBounds: rootRect,
                    intersectionRect: intersectionRect
                }));
                if (!oldEntry) {
                    this._queuedEntries.push(newEntry);
                } else if (rootIsInDom && rootContainsTarget) {
                    if (this._hasCrossedThreshold(oldEntry, newEntry)) {
                        this._queuedEntries.push(newEntry);
                    }
                } else {
                    if (oldEntry && oldEntry.isIntersecting) {
                        this._queuedEntries.push(newEntry);
                    }
                }
            }, this);
            if (this._queuedEntries.length) {
                this._callback(this.takeRecords(), this);
            }
        };
        IntersectionObserver.prototype._computeTargetAndRootIntersection = function(target, rootRect) {
            if (window.getComputedStyle(target).display == 'none') return;
            var targetRect = getBoundingClientRect(target);
            var intersectionRect = targetRect;
            var parent = getParentNode(target);
            var atRoot = false;
            while (!atRoot) {
                var parentRect = null;
                var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};
                if (parentComputedStyle.display == 'none') return;
                if (parent == this.root || parent == document) {
                    atRoot = true;
                    parentRect = rootRect;
                } else {
                    if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') {
                        parentRect = getBoundingClientRect(parent);
                    }
                }
                if (parentRect) {
                    intersectionRect = computeRectIntersection(parentRect, intersectionRect);
                    if (!intersectionRect) break;
                }
                parent = getParentNode(parent);
            }
            return intersectionRect;
        };
        IntersectionObserver.prototype._getRootRect = function() {
            var rootRect;
            if (this.root) {
                rootRect = getBoundingClientRect(this.root);
            } else {
                var html = document.documentElement;
                var body = document.body;
                rootRect = {
                    top: 0,
                    left: 0,
                    right: html.clientWidth || body.clientWidth,
                    width: html.clientWidth || body.clientWidth,
                    bottom: html.clientHeight || body.clientHeight,
                    height: html.clientHeight || body.clientHeight
                };
            }
            return this._expandRectByRootMargin(rootRect);
        };
        IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
            var margins = this._rootMarginValues.map(function(margin, i) {
                return margin.unit == 'px' ? margin.value : (margin.value * (i % 2 ? rect.width : rect.height)) / 100;
            });
            var newRect = {
                top: rect.top - margins[0],
                right: rect.right + margins[1],
                bottom: rect.bottom + margins[2],
                left: rect.left - margins[3]
            };
            newRect.width = newRect.right - newRect.left;
            newRect.height = newRect.bottom - newRect.top;
            return newRect;
        };
        IntersectionObserver.prototype._hasCrossedThreshold = function(oldEntry, newEntry) {
            var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
            var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;
            if (oldRatio === newRatio) return;
            for (var i = 0; i < this.thresholds.length; i++) {
                var threshold = this.thresholds[i];
                if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
                    return true;
                }
            }
        };
        IntersectionObserver.prototype._rootIsInDom = function() {
            return !this.root || containsDeep(document, this.root);
        };
        IntersectionObserver.prototype._rootContainsTarget = function(target) {
            return containsDeep(this.root || document, target);
        };
        IntersectionObserver.prototype._registerInstance = function() {};
        IntersectionObserver.prototype._unregisterInstance = function() {};
        function now() {
            return window.performance && performance.now && performance.now();
        }
        function throttle(fn, timeout) {
            var timer = null;
            return function() {
                if (!timer) {
                    timer = setTimeout(function() {
                        fn();
                        timer = null;
                    }, timeout);
                }
            };
        }
        function addEvent(node, event, fn, opt_useCapture) {
            if (typeof node.addEventListener == 'function') {
                node.addEventListener(event, fn, opt_useCapture || false);
            } else if (typeof node.attachEvent == 'function') {
                node.attachEvent('on' + event, fn);
            }
        }
        function removeEvent(node, event, fn, opt_useCapture) {
            if (typeof node.removeEventListener == 'function') {
                node.removeEventListener(event, fn, opt_useCapture || false);
            } else if (typeof node.detatchEvent == 'function') {
                node.detatchEvent('on' + event, fn);
            }
        }
        function computeRectIntersection(rect1, rect2) {
            var top = Math.max(rect1.top, rect2.top);
            var bottom = Math.min(rect1.bottom, rect2.bottom);
            var left = Math.max(rect1.left, rect2.left);
            var right = Math.min(rect1.right, rect2.right);
            var width = right - left;
            var height = bottom - top;
            return (
                width >= 0 &&
                height >= 0 && {
                    top: top,
                    bottom: bottom,
                    left: left,
                    right: right,
                    width: width,
                    height: height
                }
            );
        }
        function getBoundingClientRect(el) {
            var rect;
            try {
                rect = el.getBoundingClientRect();
            } catch (err) {}
            if (!rect) return getEmptyRect();
            if (!(rect.width && rect.height)) {
                rect = {
                    top: rect.top,
                    right: rect.right,
                    bottom: rect.bottom,
                    left: rect.left,
                    width: rect.right - rect.left,
                    height: rect.bottom - rect.top
                };
            }
            return rect;
        }
        function getEmptyRect() {
            return {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: 0,
                height: 0
            };
        }
        function containsDeep(parent, child) {
            var node = child;
            while (node) {
                if (node == parent) return true;
                node = getParentNode(node);
            }
            return false;
        }
        function getParentNode(node) {
            var parent = node.parentNode;
            if (parent && parent.nodeType == 11 && parent.host) {
                return parent.host;
            }
            return parent;
        }
        window.IntersectionObserver = IntersectionObserver;
        window.IntersectionObserverEntry = IntersectionObserverEntry;
    })(window, document);
    (function() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function(callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    })();
    (function() {
        if (!Object.entries) {
            Object.entries = function(obj) {
                var ownProps = Object.keys(obj),
                    i = ownProps.length,
                    resArray = new Array(i);
                while (i--) {
                    resArray[i] = [ownProps[i], obj[ownProps[i]]];
                }
                return resArray;
            };
        }
    })();
    var global$1 = typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {};
    function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout() {
        throw new Error('clearTimeout has not been defined');
    }
    var cachedSetTimeout = defaultSetTimout;
    var cachedClearTimeout = defaultClearTimeout;
    if (typeof global$1.setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
    }
    if (typeof global$1.clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
    }
    function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
            return setTimeout(fun, 0);
        }
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
        }
        try {
            return cachedSetTimeout(fun, 0);
        } catch (e) {
            try {
                return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
                return cachedSetTimeout.call(this, fun, 0);
            }
        }
    }
    function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
            return clearTimeout(marker);
        }
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
        }
        try {
            return cachedClearTimeout(marker);
        } catch (e) {
            try {
                return cachedClearTimeout.call(null, marker);
            } catch (e) {
                return cachedClearTimeout.call(this, marker);
            }
        }
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;
    function cleanUpNextTick() {
        if (!draining || !currentQueue) {
            return;
        }
        draining = false;
        if (currentQueue.length) {
            queue = currentQueue.concat(queue);
        } else {
            queueIndex = -1;
        }
        if (queue.length) {
            drainQueue();
        }
    }
    function drainQueue() {
        if (draining) {
            return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
        var len = queue.length;
        while (len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
                if (currentQueue) {
                    currentQueue[queueIndex].run();
                }
            }
            queueIndex = -1;
            len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
    }
    function nextTick(fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
        }
    }
    function Item(fun, array) {
        this.fun = fun;
        this.array = array;
    }
    Item.prototype.run = function() {
        this.fun.apply(null, this.array);
    };
    var title = 'browser';
    var platform = 'browser';
    var browser = true;
    var env = {};
    var argv = [];
    var version = '';
    var versions = {};
    var release = {};
    var config = {};
    function noop() {}
    var on = noop;
    var addListener = noop;
    var once = noop;
    var off = noop;
    var removeListener = noop;
    var removeAllListeners = noop;
    var emit = noop;
    function binding(name) {
        throw new Error('process.binding is not supported');
    }
    function cwd() {
        return '/';
    }
    function chdir(dir) {
        throw new Error('process.chdir is not supported');
    }
    function umask() {
        return 0;
    }
    var performance$1 = global$1.performance || {};
    var performanceNow =
        performance$1.now ||
        performance$1.mozNow ||
        performance$1.msNow ||
        performance$1.oNow ||
        performance$1.webkitNow ||
        function() {
            return new Date().getTime();
        };
    function hrtime(previousTimestamp) {
        var clocktime = performanceNow.call(performance$1) * 0.001;
        var seconds = Math.floor(clocktime);
        var nanoseconds = Math.floor((clocktime % 1) * 1e9);
        if (previousTimestamp) {
            seconds = seconds - previousTimestamp[0];
            nanoseconds = nanoseconds - previousTimestamp[1];
            if (nanoseconds < 0) {
                seconds--;
                nanoseconds += 1e9;
            }
        }
        return [seconds, nanoseconds];
    }
    var startTime = new Date();
    function uptime() {
        var currentTime = new Date();
        var dif = currentTime - startTime;
        return dif / 1e3;
    }
    var process = {
        nextTick: nextTick,
        title: title,
        browser: browser,
        env: env,
        argv: argv,
        version: version,
        versions: versions,
        on: on,
        addListener: addListener,
        once: once,
        off: off,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners,
        emit: emit,
        binding: binding,
        cwd: cwd,
        chdir: chdir,
        umask: umask,
        hrtime: hrtime,
        platform: platform,
        release: release,
        config: config,
        uptime: uptime
    };
    var s = 1e3;
    var m = s * 60;
    var h = m * 60;
    var d = h * 24;
    var y = d * 365.25;
    var ms = function ms(val, options) {
        options = options || {};
        var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
        if (type === 'string' && val.length > 0) {
            return parse(val);
        } else if (type === 'number' && isNaN(val) === false) {
            return options.long ? fmtLong(val) : fmtShort(val);
        }
        throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
    };
    function parse(str) {
        str = String(str);
        if (str.length > 100) {
            return;
        }
        var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
        if (!match) {
            return;
        }
        var n = parseFloat(match[1]);
        var type = (match[2] || 'ms').toLowerCase();
        switch (type) {
            case 'years':
            case 'year':
            case 'yrs':
            case 'yr':
            case 'y':
                return n * y;

            case 'days':
            case 'day':
            case 'd':
                return n * d;

            case 'hours':
            case 'hour':
            case 'hrs':
            case 'hr':
            case 'h':
                return n * h;

            case 'minutes':
            case 'minute':
            case 'mins':
            case 'min':
            case 'm':
                return n * m;

            case 'seconds':
            case 'second':
            case 'secs':
            case 'sec':
            case 's':
                return n * s;

            case 'milliseconds':
            case 'millisecond':
            case 'msecs':
            case 'msec':
            case 'ms':
                return n;

            default:
                return undefined;
        }
    }
    function fmtShort(ms) {
        if (ms >= d) {
            return Math.round(ms / d) + 'd';
        }
        if (ms >= h) {
            return Math.round(ms / h) + 'h';
        }
        if (ms >= m) {
            return Math.round(ms / m) + 'm';
        }
        if (ms >= s) {
            return Math.round(ms / s) + 's';
        }
        return ms + 'ms';
    }
    function fmtLong(ms) {
        return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
    }
    function plural(ms, n, name) {
        if (ms < n) {
            return;
        }
        if (ms < n * 1.5) {
            return Math.floor(ms / n) + ' ' + name;
        }
        return Math.ceil(ms / n) + ' ' + name + 's';
    }
    var debug = createCommonjsModule(function(module, exports) {
        exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
        exports.coerce = coerce;
        exports.disable = disable;
        exports.enable = enable;
        exports.enabled = enabled;
        exports.humanize = ms;
        exports.instances = [];
        exports.names = [];
        exports.skips = [];
        exports.formatters = {};
        function selectColor(namespace) {
            var hash = 0,
                i;
            for (i in namespace) {
                hash = (hash << 5) - hash + namespace.charCodeAt(i);
                hash |= 0;
            }
            return exports.colors[Math.abs(hash) % exports.colors.length];
        }
        function createDebug(namespace) {
            var prevTime;
            function debug() {
                if (!debug.enabled) return;
                var self = debug;
                var curr = +new Date();
                var ms$$1 = curr - (prevTime || curr);
                self.diff = ms$$1;
                self.prev = prevTime;
                self.curr = curr;
                prevTime = curr;
                var args = new Array(arguments.length);
                for (var i = 0; i < args.length; i++) {
                    args[i] = arguments[i];
                }
                args[0] = exports.coerce(args[0]);
                if ('string' !== typeof args[0]) {
                    args.unshift('%O');
                }
                var index = 0;
                args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
                    if (match === '%%') return match;
                    index++;
                    var formatter = exports.formatters[format];
                    if ('function' === typeof formatter) {
                        var val = args[index];
                        match = formatter.call(self, val);
                        args.splice(index, 1);
                        index--;
                    }
                    return match;
                });
                exports.formatArgs.call(self, args);
                var logFn = debug.log || exports.log || console.log.bind(console);
                logFn.apply(self, args);
            }
            debug.namespace = namespace;
            debug.enabled = exports.enabled(namespace);
            debug.useColors = exports.useColors();
            debug.color = selectColor(namespace);
            debug.destroy = destroy;
            if ('function' === typeof exports.init) {
                exports.init(debug);
            }
            exports.instances.push(debug);
            return debug;
        }
        function destroy() {
            var index = exports.instances.indexOf(this);
            if (index !== -1) {
                exports.instances.splice(index, 1);
                return true;
            } else {
                return false;
            }
        }
        function enable(namespaces) {
            exports.save(namespaces);
            exports.names = [];
            exports.skips = [];
            var i;
            var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
            var len = split.length;
            for (i = 0; i < len; i++) {
                if (!split[i]) continue;
                namespaces = split[i].replace(/\*/g, '.*?');
                if (namespaces[0] === '-') {
                    exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
                } else {
                    exports.names.push(new RegExp('^' + namespaces + '$'));
                }
            }
            for (i = 0; i < exports.instances.length; i++) {
                var instance = exports.instances[i];
                instance.enabled = exports.enabled(instance.namespace);
            }
        }
        function disable() {
            exports.enable('');
        }
        function enabled(name) {
            if (name[name.length - 1] === '*') {
                return true;
            }
            var i, len;
            for (i = 0, len = exports.skips.length; i < len; i++) {
                if (exports.skips[i].test(name)) {
                    return false;
                }
            }
            for (i = 0, len = exports.names.length; i < len; i++) {
                if (exports.names[i].test(name)) {
                    return true;
                }
            }
            return false;
        }
        function coerce(val) {
            if (val instanceof Error) return val.stack || val.message;
            return val;
        }
    });
    var debug_1 = debug.coerce;
    var debug_2 = debug.disable;
    var debug_3 = debug.enable;
    var debug_4 = debug.enabled;
    var debug_5 = debug.humanize;
    var debug_6 = debug.instances;
    var debug_7 = debug.names;
    var debug_8 = debug.skips;
    var debug_9 = debug.formatters;
    var browser$1 = createCommonjsModule(function(module, exports) {
        exports = module.exports = debug;
        exports.log = log;
        exports.formatArgs = formatArgs;
        exports.save = save;
        exports.load = load;
        exports.useColors = useColors;
        exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
        exports.colors = [
            '#0000CC',
            '#0000FF',
            '#0033CC',
            '#0033FF',
            '#0066CC',
            '#0066FF',
            '#0099CC',
            '#0099FF',
            '#00CC00',
            '#00CC33',
            '#00CC66',
            '#00CC99',
            '#00CCCC',
            '#00CCFF',
            '#3300CC',
            '#3300FF',
            '#3333CC',
            '#3333FF',
            '#3366CC',
            '#3366FF',
            '#3399CC',
            '#3399FF',
            '#33CC00',
            '#33CC33',
            '#33CC66',
            '#33CC99',
            '#33CCCC',
            '#33CCFF',
            '#6600CC',
            '#6600FF',
            '#6633CC',
            '#6633FF',
            '#66CC00',
            '#66CC33',
            '#9900CC',
            '#9900FF',
            '#9933CC',
            '#9933FF',
            '#99CC00',
            '#99CC33',
            '#CC0000',
            '#CC0033',
            '#CC0066',
            '#CC0099',
            '#CC00CC',
            '#CC00FF',
            '#CC3300',
            '#CC3333',
            '#CC3366',
            '#CC3399',
            '#CC33CC',
            '#CC33FF',
            '#CC6600',
            '#CC6633',
            '#CC9900',
            '#CC9933',
            '#CCCC00',
            '#CCCC33',
            '#FF0000',
            '#FF0033',
            '#FF0066',
            '#FF0099',
            '#FF00CC',
            '#FF00FF',
            '#FF3300',
            '#FF3333',
            '#FF3366',
            '#FF3399',
            '#FF33CC',
            '#FF33FF',
            '#FF6600',
            '#FF6633',
            '#FF9900',
            '#FF9933',
            '#FFCC00',
            '#FFCC33'
        ];
        function useColors() {
            if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
                return true;
            }
            if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
                return false;
            }
            return (
                (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
                (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
                (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
                (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))
            );
        }
        exports.formatters.j = function(v) {
            try {
                return JSON.stringify(v);
            } catch (err) {
                return '[UnexpectedJSONParseError]: ' + err.message;
            }
        };
        function formatArgs(args) {
            var useColors = this.useColors;
            args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
            if (!useColors) return;
            var c = 'color: ' + this.color;
            args.splice(1, 0, c, 'color: inherit');
            var index = 0;
            var lastC = 0;
            args[0].replace(/%[a-zA-Z%]/g, function(match) {
                if ('%%' === match) return;
                index++;
                if ('%c' === match) {
                    lastC = index;
                }
            });
            args.splice(lastC, 0, c);
        }
        function log() {
            return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
        }
        function save(namespaces) {
            try {
                if (null == namespaces) {
                    exports.storage.removeItem('debug');
                } else {
                    exports.storage.debug = namespaces;
                }
            } catch (e) {}
        }
        function load() {
            var r;
            try {
                r = exports.storage.debug;
            } catch (e) {}
            if (!r && typeof process !== 'undefined' && 'env' in process) {
                r = process.env.DEBUG;
            }
            return r;
        }
        exports.enable(load());
        function localstorage() {
            try {
                return window.localStorage;
            } catch (e) {}
        }
    });
    var browser_1 = browser$1.log;
    var browser_2 = browser$1.formatArgs;
    var browser_3 = browser$1.save;
    var browser_4 = browser$1.load;
    var browser_5 = browser$1.useColors;
    var browser_6 = browser$1.storage;
    var browser_7 = browser$1.colors;
    function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    var _basePropertyOf = basePropertyOf;
    var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    var escapeHtmlChar = _basePropertyOf(htmlEscapes);
    var _escapeHtmlChar = escapeHtmlChar;
    var reUnescapedHtml = /[&<>"']/g,
        reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    function escape(string) {
        string = toString_1(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, _escapeHtmlChar) : string;
    }
    var _escape = escape;
    var parseQueryString = function parseQueryString() {
        var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search.substring(1);
        var params = {};
        var queries = queryString.split('&');
        queries.forEach(function(query) {
            var _query$split = query.split('='),
                _query$split2 = slicedToArray(_query$split, 2),
                name = _query$split2[0],
                value = _query$split2[1];
            params[_escape(name)] = _escape(value);
        });
        return params;
    };
    var getQueryString = function getQueryString(str) {
        var params = parseQueryString();
        if (str in params) {
            return params[str];
        }
        return '';
    };
    if ('production' !== 'production' || getQueryString('beamDebug')) {
        browser$1.enable('beam*');
        browser$1.log = console.log.bind(console);
    } else {
        browser$1.disable();
    }
    var debug$1 = function() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'debug';
        return browser$1('beam:' + name);
    };
    var eventName = 'TRACK_ANALYTICS';
    function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    var _overArg = overArg;
    var getPrototype = _overArg(Object.getPrototypeOf, Object);
    var _getPrototype = getPrototype;
    var objectTag = '[object Object]';
    var funcProto = Function.prototype,
        objectProto$2 = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
    var objectCtorString = funcToString.call(Object);
    function isPlainObject(value) {
        if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag) {
            return false;
        }
        var proto = _getPrototype(value);
        if (proto === null) {
            return true;
        }
        var Ctor = hasOwnProperty$1.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    var isPlainObject_1 = isPlainObject;
    function arrayEach(array, iteratee) {
        var index = -1,
            length = array == null ? 0 : array.length;
        while (++index < length) {
            if (iteratee(array[index], index, array) === false) {
                break;
            }
        }
        return array;
    }
    var _arrayEach = arrayEach;
    function createBaseFor(fromRight) {
        return function(object, iteratee, keysFunc) {
            var index = -1,
                iterable = Object(object),
                props = keysFunc(object),
                length = props.length;
            while (length--) {
                var key = props[fromRight ? length : ++index];
                if (iteratee(iterable[key], key, iterable) === false) {
                    break;
                }
            }
            return object;
        };
    }
    var _createBaseFor = createBaseFor;
    var baseFor = _createBaseFor();
    var _baseFor = baseFor;
    function baseTimes(n, iteratee) {
        var index = -1,
            result = Array(n);
        while (++index < n) {
            result[index] = iteratee(index);
        }
        return result;
    }
    var _baseTimes = baseTimes;
    var argsTag = '[object Arguments]';
    function baseIsArguments(value) {
        return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
    }
    var _baseIsArguments = baseIsArguments;
    var objectProto$3 = Object.prototype;
    var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
    var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
    var isArguments = _baseIsArguments(
        (function() {
            return arguments;
        })()
    )
        ? _baseIsArguments
        : function(value) {
                return isObjectLike_1(value) && hasOwnProperty$2.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
          };
    var isArguments_1 = isArguments;
    function stubFalse() {
        return false;
    }
    var stubFalse_1 = stubFalse;
    var isBuffer_1 = createCommonjsModule(function(module, exports) {
        var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;
        var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var Buffer = moduleExports ? _root.Buffer : undefined;
        var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
        var isBuffer = nativeIsBuffer || stubFalse_1;
        module.exports = isBuffer;
    });
    var MAX_SAFE_INTEGER = 9007199254740991;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value, length) {
        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == 'number' || (type != 'symbol' && reIsUint.test(value))) && value > -1 && value % 1 == 0 && value < length;
    }
    var _isIndex = isIndex;
    var MAX_SAFE_INTEGER$1 = 9007199254740991;
    function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
    }
    var isLength_1 = isLength;
    var argsTag$1 = '[object Arguments]',
        arrayTag = '[object Array]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        errorTag = '[object Error]',
        funcTag$1 = '[object Function]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        objectTag$1 = '[object Object]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        weakMapTag = '[object WeakMap]';
    var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[
        uint8ClampedTag
    ] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[
        errorTag
    ] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[
        stringTag
    ] = typedArrayTags[weakMapTag] = false;
    function baseIsTypedArray(value) {
        return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
    }
    var _baseIsTypedArray = baseIsTypedArray;
    function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    var _baseUnary = baseUnary;
    var _nodeUtil = createCommonjsModule(function(module, exports) {
        var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;
        var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var freeProcess = moduleExports && _freeGlobal.process;
        var nodeUtil = (function() {
            try {
                return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
        })();
        module.exports = nodeUtil;
    });
    var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
    var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
    var isTypedArray_1 = isTypedArray;
    var objectProto$4 = Object.prototype;
    var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
    function arrayLikeKeys(value, inherited) {
        var isArr = isArray_1(value),
            isArg = !isArr && isArguments_1(value),
            isBuff = !isArr && !isArg && isBuffer_1(value),
            isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
            skipIndexes = isArr || isArg || isBuff || isType,
            result = skipIndexes ? _baseTimes(value.length, String) : [],
            length = result.length;
        for (var key in value) {
            if (
                (inherited || hasOwnProperty$3.call(value, key)) &&
                !(
                    skipIndexes &&
                    (key == 'length' || (isBuff && (key == 'offset' || key == 'parent')) || (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) || _isIndex(key, length))
                )
            ) {
                result.push(key);
            }
        }
        return result;
    }
    var _arrayLikeKeys = arrayLikeKeys;
    var objectProto$5 = Object.prototype;
    function isPrototype(value) {
        var Ctor = value && value.constructor,
            proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;
        return value === proto;
    }
    var _isPrototype = isPrototype;
    var nativeKeys = _overArg(Object.keys, Object);
    var _nativeKeys = nativeKeys;
    var objectProto$6 = Object.prototype;
    var hasOwnProperty$4 = objectProto$6.hasOwnProperty;
    function baseKeys(object) {
        if (!_isPrototype(object)) {
            return _nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
            if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
                result.push(key);
            }
        }
        return result;
    }
    var _baseKeys = baseKeys;
    function isArrayLike(value) {
        return value != null && isLength_1(value.length) && !isFunction_1(value);
    }
    var isArrayLike_1 = isArrayLike;
    function keys(object) {
        return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
    }
    var keys_1 = keys;
    function baseForOwn(object, iteratee) {
        return object && _baseFor(object, iteratee, keys_1);
    }
    var _baseForOwn = baseForOwn;
    function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee) {
            if (collection == null) {
                return collection;
            }
            if (!isArrayLike_1(collection)) {
                return eachFunc(collection, iteratee);
            }
            var length = collection.length,
                index = fromRight ? length : -1,
                iterable = Object(collection);
            while (fromRight ? index-- : ++index < length) {
                if (iteratee(iterable[index], index, iterable) === false) {
                    break;
                }
            }
            return collection;
        };
    }
    var _createBaseEach = createBaseEach;
    var baseEach = _createBaseEach(_baseForOwn);
    var _baseEach = baseEach;
    function identity(value) {
        return value;
    }
    var identity_1 = identity;
    function castFunction(value) {
        return typeof value == 'function' ? value : identity_1;
    }
    var _castFunction = castFunction;
    function forEach(collection, iteratee) {
        var func = isArray_1(collection) ? _arrayEach : _baseEach;
        return func(collection, _castFunction(iteratee));
    }
    var forEach_1 = forEach;
    function isUndefined(value) {
        return value === undefined;
    }
    var isUndefined_1 = isUndefined;
    var eventList = {
        ApplicationClicked: {
            type: 'redventures.usertracking.v3.ApplicationClicked',
            event: 'click'
        },
        ElementClicked: {
            type: 'redventures.usertracking.v3.ElementClicked',
            event: 'click'
        },
        ElementSwiped: {
            type: 'redventures.usertracking.v3.ElementSwiped',
            event: 'swipe'
        },
        ElementViewed: {
            type: 'redventures.usertracking.v3.ElementViewed',
            event: 'view'
        },
        HopPageViewed: {
            type: 'redventures.creditcards.v1.HopPageViewed',
            event: 'view'
        },
        ProductAdded: {
            type: 'redventures.ecommerce.v1.ProductAdded',
            event: 'click'
        },
        ProductClicked: {
            type: 'redventures.ecommerce.v1.ProductClicked',
            event: 'click'
        },
        PageScrolled: {
            type: 'redventures.usertracking.v3.PageScrolled',
            event: 'scroll'
        },
        ProductViewed: {
            type: 'redventures.ecommerce.v1.ProductViewed',
            event: 'view'
        },
        FieldInputted: {
            type: 'redventures.usertracking.v3.FieldInputted',
            event: 'change'
        },
        FieldSelected: {
            type: 'redventures.usertracking.v3.FieldSelected',
            event: 'change'
        },
        FormBacked: {
            type: 'redventures.usertracking.v3.FormBacked',
            event: 'click'
        },
        FormContinued: {
            type: 'redventures.usertracking.v3.FormContinued',
            event: 'click'
        },
        FormExited: {
            type: 'redventures.usertracking.v3.FormExited',
            event: 'click'
        },
        FormRestarted: {
            type: 'redventures.usertracking.v3.FormRestarted',
            event: 'click'
        },
        FormStarted: {
            type: 'redventures.usertracking.v3.FormStarted',
            event: 'click'
        },
        FormSubmitted: {
            type: 'redventures.usertracking.v3.FormSubmitted',
            event: 'submit'
        },
        FormViewed: {
            type: 'redventures.usertracking.v3.FormViewed',
            event: 'view'
        }
    };
    var getEventType = function(type) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (config && config.event) {
            return config.event;
        }
        var eventType = eventList[type];
        if (eventType && 'event' in eventType) {
            return eventType.event;
        }
        return false;
    };
    var event = new CustomEvent(eventName, {
        bubbles: true,
        cancelable: true
    });
    var log = debug$1('clickHandler');
    var clickHandler = function(event$$1) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var el = event$$1.target;
        var href = el.getAttribute('href');
        var delay = config && 'delay' in config ? config.delay : true;
        el.dispatchEvent(event);
        if (delay && href && href.indexOf('#') !== 0 && el.getAttribute('target') !== '_blank') {
            event$$1.preventDefault();
            log('Delaying link follow slightly to allow "beam" to send.');
            setTimeout(function() {
                window.location = el.href;
            }, 100);
        }
    };
    function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
    }
    var _listCacheClear = listCacheClear;
    function eq(value, other) {
        return value === other || (value !== value && other !== other);
    }
    var eq_1 = eq;
    function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
            if (eq_1(array[length][0], key)) {
                return length;
            }
        }
        return -1;
    }
    var _assocIndexOf = assocIndexOf;
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key) {
        var data = this.__data__,
            index = _assocIndexOf(data, key);
        if (index < 0) {
            return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
            data.pop();
        } else {
            splice.call(data, index, 1);
        }
        --this.size;
        return true;
    }
    var _listCacheDelete = listCacheDelete;
    function listCacheGet(key) {
        var data = this.__data__,
            index = _assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
    }
    var _listCacheGet = listCacheGet;
    function listCacheHas(key) {
        return _assocIndexOf(this.__data__, key) > -1;
    }
    var _listCacheHas = listCacheHas;
    function listCacheSet(key, value) {
        var data = this.__data__,
            index = _assocIndexOf(data, key);
        if (index < 0) {
            ++this.size;
            data.push([key, value]);
        } else {
            data[index][1] = value;
        }
        return this;
    }
    var _listCacheSet = listCacheSet;
    function ListCache(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    ListCache.prototype.clear = _listCacheClear;
    ListCache.prototype['delete'] = _listCacheDelete;
    ListCache.prototype.get = _listCacheGet;
    ListCache.prototype.has = _listCacheHas;
    ListCache.prototype.set = _listCacheSet;
    var _ListCache = ListCache;
    function stackClear() {
        this.__data__ = new _ListCache();
        this.size = 0;
    }
    var _stackClear = stackClear;
    function stackDelete(key) {
        var data = this.__data__,
            result = data['delete'](key);
        this.size = data.size;
        return result;
    }
    var _stackDelete = stackDelete;
    function stackGet(key) {
        return this.__data__.get(key);
    }
    var _stackGet = stackGet;
    function stackHas(key) {
        return this.__data__.has(key);
    }
    var _stackHas = stackHas;
    var coreJsData = _root['__core-js_shared__'];
    var _coreJsData = coreJsData;
    var maskSrcKey = (function() {
        var uid = /[^.]+$/.exec((_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO) || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
    })();
    function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
    }
    var _isMasked = isMasked;
    var funcProto$1 = Function.prototype;
    var funcToString$1 = funcProto$1.toString;
    function toSource(func) {
        if (func != null) {
            try {
                return funcToString$1.call(func);
            } catch (e) {}
            try {
                return func + '';
            } catch (e) {}
        }
        return '';
    }
    var _toSource = toSource;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto$2 = Function.prototype,
        objectProto$7 = Object.prototype;
    var funcToString$2 = funcProto$2.toString;
    var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
    var reIsNative = RegExp(
        '^' +
            funcToString$2
                .call(hasOwnProperty$5)
                .replace(reRegExpChar, '\\$&')
                .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') +
            '$'
    );
    function baseIsNative(value) {
        if (!isObject_1(value) || _isMasked(value)) {
            return false;
        }
        var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
        return pattern.test(_toSource(value));
    }
    var _baseIsNative = baseIsNative;
    function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    var _getValue = getValue;
    function getNative(object, key) {
        var value = _getValue(object, key);
        return _baseIsNative(value) ? value : undefined;
    }
    var _getNative = getNative;
    var Map = _getNative(_root, 'Map');
    var _Map = Map;
    var nativeCreate = _getNative(Object, 'create');
    var _nativeCreate = nativeCreate;
    function hashClear() {
        this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
        this.size = 0;
    }
    var _hashClear = hashClear;
    function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
    }
    var _hashDelete = hashDelete;
    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    var objectProto$8 = Object.prototype;
    var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
    function hashGet(key) {
        var data = this.__data__;
        if (_nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty$6.call(data, key) ? data[key] : undefined;
    }
    var _hashGet = hashGet;
    var objectProto$9 = Object.prototype;
    var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
    function hashHas(key) {
        var data = this.__data__;
        return _nativeCreate ? data[key] !== undefined : hasOwnProperty$7.call(data, key);
    }
    var _hashHas = hashHas;
    var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
    function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
        return this;
    }
    var _hashSet = hashSet;
    function Hash(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    Hash.prototype.clear = _hashClear;
    Hash.prototype['delete'] = _hashDelete;
    Hash.prototype.get = _hashGet;
    Hash.prototype.has = _hashHas;
    Hash.prototype.set = _hashSet;
    var _Hash = Hash;
    function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
            hash: new _Hash(),
            map: new (_Map || _ListCache)(),
            string: new _Hash()
        };
    }
    var _mapCacheClear = mapCacheClear;
    function isKeyable(value) {
        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }
    var _isKeyable = isKeyable;
    function getMapData(map, key) {
        var data = map.__data__;
        return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }
    var _getMapData = getMapData;
    function mapCacheDelete(key) {
        var result = _getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
    }
    var _mapCacheDelete = mapCacheDelete;
    function mapCacheGet(key) {
        return _getMapData(this, key).get(key);
    }
    var _mapCacheGet = mapCacheGet;
    function mapCacheHas(key) {
        return _getMapData(this, key).has(key);
    }
    var _mapCacheHas = mapCacheHas;
    function mapCacheSet(key, value) {
        var data = _getMapData(this, key),
            size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
    }
    var _mapCacheSet = mapCacheSet;
    function MapCache(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    MapCache.prototype.clear = _mapCacheClear;
    MapCache.prototype['delete'] = _mapCacheDelete;
    MapCache.prototype.get = _mapCacheGet;
    MapCache.prototype.has = _mapCacheHas;
    MapCache.prototype.set = _mapCacheSet;
    var _MapCache = MapCache;
    var LARGE_ARRAY_SIZE = 200;
    function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof _ListCache) {
            var pairs = data.__data__;
            if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                pairs.push([key, value]);
                this.size = ++data.size;
                return this;
            }
            data = this.__data__ = new _MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
    }
    var _stackSet = stackSet;
    function Stack(entries) {
        var data = (this.__data__ = new _ListCache(entries));
        this.size = data.size;
    }
    Stack.prototype.clear = _stackClear;
    Stack.prototype['delete'] = _stackDelete;
    Stack.prototype.get = _stackGet;
    Stack.prototype.has = _stackHas;
    Stack.prototype.set = _stackSet;
    var _Stack = Stack;
    var defineProperty$1 = (function() {
        try {
            var func = _getNative(Object, 'defineProperty');
            func({}, '', {});
            return func;
        } catch (e) {}
    })();
    var _defineProperty = defineProperty$1;
    function baseAssignValue(object, key, value) {
        if (key == '__proto__' && _defineProperty) {
            _defineProperty(object, key, {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        } else {
            object[key] = value;
        }
    }
    var _baseAssignValue = baseAssignValue;
    function assignMergeValue(object, key, value) {
        if ((value !== undefined && !eq_1(object[key], value)) || (value === undefined && !(key in object))) {
            _baseAssignValue(object, key, value);
        }
    }
    var _assignMergeValue = assignMergeValue;
    var _cloneBuffer = createCommonjsModule(function(module, exports) {
        var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;
        var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var Buffer = moduleExports ? _root.Buffer : undefined,
            allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
        function cloneBuffer(buffer, isDeep) {
            if (isDeep) {
                return buffer.slice();
            }
            var length = buffer.length,
                result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        module.exports = cloneBuffer;
    });
    var Uint8Array = _root.Uint8Array;
    var _Uint8Array = Uint8Array;
    function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
        return result;
    }
    var _cloneArrayBuffer = cloneArrayBuffer;
    function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    var _cloneTypedArray = cloneTypedArray;
    function copyArray(source, array) {
        var index = -1,
            length = source.length;
        array || (array = Array(length));
        while (++index < length) {
            array[index] = source[index];
        }
        return array;
    }
    var _copyArray = copyArray;
    var objectCreate = Object.create;
    var baseCreate = (function() {
        function object() {}
        return function(proto) {
            if (!isObject_1(proto)) {
                return {};
            }
            if (objectCreate) {
                return objectCreate(proto);
            }
            object.prototype = proto;
            var result = new object();
            object.prototype = undefined;
            return result;
        };
    })();
    var _baseCreate = baseCreate;
    function initCloneObject(object) {
        return typeof object.constructor == 'function' && !_isPrototype(object) ? _baseCreate(_getPrototype(object)) : {};
    }
    var _initCloneObject = initCloneObject;
    function isArrayLikeObject(value) {
        return isObjectLike_1(value) && isArrayLike_1(value);
    }
    var isArrayLikeObject_1 = isArrayLikeObject;
    function safeGet(object, key) {
        return key == '__proto__' ? undefined : object[key];
    }
    var _safeGet = safeGet;
    var objectProto$10 = Object.prototype;
    var hasOwnProperty$8 = objectProto$10.hasOwnProperty;
    function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty$8.call(object, key) && eq_1(objValue, value)) || (value === undefined && !(key in object))) {
            _baseAssignValue(object, key, value);
        }
    }
    var _assignValue = assignValue;
    function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1,
            length = props.length;
        while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
            if (newValue === undefined) {
                newValue = source[key];
            }
            if (isNew) {
                _baseAssignValue(object, key, newValue);
            } else {
                _assignValue(object, key, newValue);
            }
        }
        return object;
    }
    var _copyObject = copyObject;
    function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
            for (var key in Object(object)) {
                result.push(key);
            }
        }
        return result;
    }
    var _nativeKeysIn = nativeKeysIn;
    var objectProto$11 = Object.prototype;
    var hasOwnProperty$9 = objectProto$11.hasOwnProperty;
    function baseKeysIn(object) {
        if (!isObject_1(object)) {
            return _nativeKeysIn(object);
        }
        var isProto = _isPrototype(object),
            result = [];
        for (var key in object) {
            if (!(key == 'constructor' && (isProto || !hasOwnProperty$9.call(object, key)))) {
                result.push(key);
            }
        }
        return result;
    }
    var _baseKeysIn = baseKeysIn;
    function keysIn(object) {
        return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
    }
    var keysIn_1 = keysIn;
    function toPlainObject(value) {
        return _copyObject(value, keysIn_1(value));
    }
    var toPlainObject_1 = toPlainObject;
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = _safeGet(object, key),
            srcValue = _safeGet(source, key),
            stacked = stack.get(srcValue);
        if (stacked) {
            _assignMergeValue(object, key, stacked);
            return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
        var isCommon = newValue === undefined;
        if (isCommon) {
            var isArr = isArray_1(srcValue),
                isBuff = !isArr && isBuffer_1(srcValue),
                isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
                if (isArray_1(objValue)) {
                    newValue = objValue;
                } else if (isArrayLikeObject_1(objValue)) {
                    newValue = _copyArray(objValue);
                } else if (isBuff) {
                    isCommon = false;
                    newValue = _cloneBuffer(srcValue, true);
                } else if (isTyped) {
                    isCommon = false;
                    newValue = _cloneTypedArray(srcValue, true);
                } else {
                    newValue = [];
                }
            } else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
                newValue = objValue;
                if (isArguments_1(objValue)) {
                    newValue = toPlainObject_1(objValue);
                } else if (!isObject_1(objValue) || (srcIndex && isFunction_1(objValue))) {
                    newValue = _initCloneObject(srcValue);
                }
            } else {
                isCommon = false;
            }
        }
        if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack['delete'](srcValue);
        }
        _assignMergeValue(object, key, newValue);
    }
    var _baseMergeDeep = baseMergeDeep;
    function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
            return;
        }
        _baseFor(
            source,
            function(srcValue, key) {
                if (isObject_1(srcValue)) {
                    stack || (stack = new _Stack());
                    _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                } else {
                    var newValue = customizer ? customizer(_safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) {
                        newValue = srcValue;
                    }
                    _assignMergeValue(object, key, newValue);
                }
            },
            keysIn_1
        );
    }
    var _baseMerge = baseMerge;
    function apply(func, thisArg, args) {
        switch (args.length) {
            case 0:
                return func.call(thisArg);

            case 1:
                return func.call(thisArg, args[0]);

            case 2:
                return func.call(thisArg, args[0], args[1]);

            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    var _apply = apply;
    var nativeMax = Math.max;
    function overRest(func, start, transform) {
        start = nativeMax(start === undefined ? func.length - 1 : start, 0);
        return function() {
            var args = arguments,
                index = -1,
                length = nativeMax(args.length - start, 0),
                array = Array(length);
            while (++index < length) {
                array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array(start + 1);
            while (++index < start) {
                otherArgs[index] = args[index];
            }
            otherArgs[start] = transform(array);
            return _apply(func, this, otherArgs);
        };
    }
    var _overRest = overRest;
    function constant(value) {
        return function() {
            return value;
        };
    }
    var constant_1 = constant;
    var baseSetToString = !_defineProperty
        ? identity_1
        : function(func, string) {
                return _defineProperty(func, 'toString', {
                    configurable: true,
                    enumerable: false,
                    value: constant_1(string),
                    writable: true
                });
          };
    var _baseSetToString = baseSetToString;
    var HOT_COUNT = 800,
        HOT_SPAN = 16;
    var nativeNow = Date.now;
    function shortOut(func) {
        var count = 0,
            lastCalled = 0;
        return function() {
            var stamp = nativeNow(),
                remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
                if (++count >= HOT_COUNT) {
                    return arguments[0];
                }
            } else {
                count = 0;
            }
            return func.apply(undefined, arguments);
        };
    }
    var _shortOut = shortOut;
    var setToString = _shortOut(_baseSetToString);
    var _setToString = setToString;
    function baseRest(func, start) {
        return _setToString(_overRest(func, start, identity_1), func + '');
    }
    var _baseRest = baseRest;
    function isIterateeCall(value, index, object) {
        if (!isObject_1(object)) {
            return false;
        }
        var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
        if (type == 'number' ? isArrayLike_1(object) && _isIndex(index, object.length) : type == 'string' && index in object) {
            return eq_1(object[index], value);
        }
        return false;
    }
    var _isIterateeCall = isIterateeCall;
    function createAssigner(assigner) {
        return _baseRest(function(object, sources) {
            var index = -1,
                length = sources.length,
                customizer = length > 1 ? sources[length - 1] : undefined,
                guard = length > 2 ? sources[2] : undefined;
            customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
            if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
                customizer = length < 3 ? undefined : customizer;
                length = 1;
            }
            object = Object(object);
            while (++index < length) {
                var source = sources[index];
                if (source) {
                    assigner(object, source, index, customizer);
                }
            }
            return object;
        });
    }
    var _createAssigner = createAssigner;
    var merge = _createAssigner(function(object, source, srcIndex) {
        _baseMerge(object, source, srcIndex);
    });
    var merge_1 = merge;
    function noop$1() {}
    var noop_1 = noop$1;
    var defaults$1 = {
        root: null,
        rootMargin: '0px',
        threshold: [0, 1]
    };
    var createObserver = function() {
        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop_1;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaults$1;
        var observer = new IntersectionObserver(callback, options);
        return observer;
    };
    var stringTag$1 = '[object String]';
    function isString(value) {
        return typeof value == 'string' || (!isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$1);
    }
    var isString_1 = isString;
    function isNil(value) {
        return value == null;
    }
    var isNil_1 = isNil;
    var freeGlobal$1 = (typeof global$1 === 'undefined' ? 'undefined' : _typeof(global$1)) == 'object' && global$1 && global$1.Object === Object && global$1;
    var freeSelf$1 = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;
    var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();
    var _Symbol$1 = root$1.Symbol;
    var objectProto$12 = Object.prototype;
    var hasOwnProperty$10 = objectProto$12.hasOwnProperty;
    var nativeObjectToString$2 = objectProto$12.toString;
    var symToStringTag$2 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;
    function getRawTag$1(value) {
        var isOwn = hasOwnProperty$10.call(value, symToStringTag$2),
            tag = value[symToStringTag$2];
        try {
            value[symToStringTag$2] = undefined;
            var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString$2.call(value);
        if (unmasked) {
            if (isOwn) {
                value[symToStringTag$2] = tag;
            } else {
                delete value[symToStringTag$2];
            }
        }
        return result;
    }
    var objectProto$13 = Object.prototype;
    var nativeObjectToString$3 = objectProto$13.toString;
    function objectToString$1(value) {
        return nativeObjectToString$3.call(value);
    }
    var nullTag$1 = '[object Null]',
        undefinedTag$1 = '[object Undefined]';
    var symToStringTag$3 = _Symbol$1 ? _Symbol$1.toStringTag : undefined;
    function baseGetTag$1(value) {
        if (value == null) {
            return value === undefined ? undefinedTag$1 : nullTag$1;
        }
        return symToStringTag$3 && symToStringTag$3 in Object(value) ? getRawTag$1(value) : objectToString$1(value);
    }
    function overArg$1(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    var getPrototype$1 = overArg$1(Object.getPrototypeOf, Object);
    function isObjectLike$1(value) {
        return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
    }
    var objectTag$2 = '[object Object]';
    var funcProto$3 = Function.prototype,
        objectProto$14 = Object.prototype;
    var funcToString$3 = funcProto$3.toString;
    var hasOwnProperty$11 = objectProto$14.hasOwnProperty;
    var objectCtorString$1 = funcToString$3.call(Object);
    function isPlainObject$1(value) {
        if (!isObjectLike$1(value) || baseGetTag$1(value) != objectTag$2) {
            return false;
        }
        var proto = getPrototype$1(value);
        if (proto === null) {
            return true;
        }
        var Ctor = hasOwnProperty$11.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$3.call(Ctor) == objectCtorString$1;
    }
    function symbolObservablePonyfill(root) {
        var result;
        var _Symbol = root.Symbol;
        if (typeof _Symbol === 'function') {
            if (_Symbol.observable) {
                result = _Symbol.observable;
            } else {
                result = _Symbol('observable');
                _Symbol.observable = result;
            }
        } else {
            result = '@@observable';
        }
        return result;
    }
    var root$2;
    if (typeof self !== 'undefined') {
        root$2 = self;
    } else if (typeof window !== 'undefined') {
        root$2 = window;
    } else if (typeof global$1 !== 'undefined') {
        root$2 = global$1;
    } else if (typeof module !== 'undefined') {
        root$2 = module;
    } else {
        root$2 = Function('return this')();
    }
    var result = symbolObservablePonyfill(root$2);
    var ActionTypes = {
        INIT: '@@redux/INIT'
    };
    function createStore(reducer, preloadedState, enhancer) {
        var _ref2;
        if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
            enhancer = preloadedState;
            preloadedState = undefined;
        }
        if (typeof enhancer !== 'undefined') {
            if (typeof enhancer !== 'function') {
                throw new Error('Expected the enhancer to be a function.');
            }
            return enhancer(createStore)(reducer, preloadedState);
        }
        if (typeof reducer !== 'function') {
            throw new Error('Expected the reducer to be a function.');
        }
        var currentReducer = reducer;
        var currentState = preloadedState;
        var currentListeners = [];
        var nextListeners = currentListeners;
        var isDispatching = false;
        function ensureCanMutateNextListeners() {
            if (nextListeners === currentListeners) {
                nextListeners = currentListeners.slice();
            }
        }
        function getState() {
            return currentState;
        }
        function subscribe(listener) {
            if (typeof listener !== 'function') {
                throw new Error('Expected listener to be a function.');
            }
            var isSubscribed = true;
            ensureCanMutateNextListeners();
            nextListeners.push(listener);
            return function unsubscribe() {
                if (!isSubscribed) {
                    return;
                }
                isSubscribed = false;
                ensureCanMutateNextListeners();
                var index = nextListeners.indexOf(listener);
                nextListeners.splice(index, 1);
            };
        }
        function dispatch(action) {
            if (!isPlainObject$1(action)) {
                throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
            }
            if (typeof action.type === 'undefined') {
                throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
            }
            if (isDispatching) {
                throw new Error('Reducers may not dispatch actions.');
            }
            try {
                isDispatching = true;
                currentState = currentReducer(currentState, action);
            } finally {
                isDispatching = false;
            }
            var listeners = (currentListeners = nextListeners);
            for (var i = 0; i < listeners.length; i++) {
                var listener = listeners[i];
                listener();
            }
            return action;
        }
        function replaceReducer(nextReducer) {
            if (typeof nextReducer !== 'function') {
                throw new Error('Expected the nextReducer to be a function.');
            }
            currentReducer = nextReducer;
            dispatch({
                type: ActionTypes.INIT
            });
        }
        function observable() {
            var _ref;
            var outerSubscribe = subscribe;
            return (
                (_ref = {
                    subscribe: function subscribe(observer) {
                        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object') {
                            throw new TypeError('Expected the observer to be an object.');
                        }
                        function observeState() {
                            if (observer.next) {
                                observer.next(getState());
                            }
                        }
                        observeState();
                        var unsubscribe = outerSubscribe(observeState);
                        return {
                            unsubscribe: unsubscribe
                        };
                    }
                }),
                (_ref[result] = function() {
                    return this;
                }),
                _ref
            );
        }
        dispatch({
            type: ActionTypes.INIT
        });
        return (
            (_ref2 = {
                dispatch: dispatch,
                subscribe: subscribe,
                getState: getState,
                replaceReducer: replaceReducer
            }),
            (_ref2[result] = observable),
            _ref2
        );
    }
    var ADD_VARS = 'ADD_VARS';
    var ADD_OBSERVER = 'ADD_OBSERVER';
    var ENQUEUE = 'ENQUEUE';
    var DEQUEUE = 'DEQUEUE';
    var INCREMENT_UID = 'INCREMENT_UID';
    var INITIALIZE = 'INITIALIZE';
    var MAP_DATA = 'MAP_DATA';
    var SOURCECACHE = 'SOURCECACHE';
    var SCRIPT_PATH = 'SCRIPT_PATH';
    var log$1 = debug$1('store');
    var initialState = {
        data: {},
        initialized: false,
        observers: {},
        queue: [],
        scriptPath: './',
        sourceCache: {},
        uid: 0,
        vars: {}
    };
    function cache(state, action) {
        switch (action.type) {
            case ADD_VARS:
                if (isPlainObject_1(action.vars)) {
                    merge_1(state.vars, action.vars);
                }
                return state;

            case ADD_OBSERVER:
                if (action.name && action.observer) {
                    state.observers[action.name] = action.observer;
                }
                return state;

            case ENQUEUE:
                if (isPlainObject_1(action.source)) {
                    state.queue.push(action.source);
                }
                return state;

            case DEQUEUE:
                if (state.queue.length > 0) {
                    state.queue.shift();
                }
                return state;

            case INCREMENT_UID:
                state.uid += 1;
                return state;

            case INITIALIZE:
                state.initialized = true;
                return state;

            case MAP_DATA:
                if (action.uid >= 0 && isPlainObject_1(action.data)) {
                    state.data[action.uid] = action.data;
                }
                return state;

            case SOURCECACHE:
                if (isPlainObject_1(action.source)) {
                    merge_1(state.sourceCache, action.source);
                }
                return state;

            case SCRIPT_PATH:
                if (isString_1(action.path)) {
                    var paths = action.path
                        .split('/')
                        .map(function(part) {
                            return _escape(part.replace(/https?:|\?/gi, ''));
                        })
                        .filter(function(part) {
                            return !isNil_1(part) && part.length > 0;
                        });
                    state.scriptPath = paths.join('/');
                }
                return state;

            case '@@INIT':
                return state;

            default:
                log$1('Action type not found.', action.type);
                return state;
        }
    }
    var store = createStore(cache, initialState, typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
    var log$2 = debug$1('observer');
    var defaults$2 = {
        root: null,
        rootMargin: '25% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1]
    };
    var observerHandler = function observerHandler(entries, observer) {
        entries.forEach(function(entry) {
            var isIntersecting = entry.isIntersecting,
                target = entry.target;
            if (isIntersecting) {
                target.dispatchEvent(event);
                observer.unobserve(target);
            }
        });
    };
    var observer = function(el) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _store$getState = store.getState(),
            observers = _store$getState.observers;
        var observer = observers[name];
        if (!observer) {
            log$2('Creating new observer for: "' + name + '"');
            var options = merge_1({}, defaults$2, config);
            observer = createObserver(observerHandler, options);
            store.dispatch({
                type: ADD_OBSERVER,
                name: name,
                observer: observer
            });
        }
        observer.observe(el);
    };
    var log$3 = debug$1('bind');
    var alreadyBound = function alreadyBound(el) {
        return !isUndefined_1(el.dataset.tagularUid);
    };
    var bind = function(elements, protobuf) {
        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var type = protobuf['@type'];
        if (!type) {
            return;
        }
        forEach_1(elements, function(el, index) {
            var eventType = getEventType(type, config);
            var _store$getState = store.getState(),
                uid = _store$getState.uid;
            if (!eventType || alreadyBound(el)) {
                log$3('No event type specified, or is already bound.', type, el);
                return;
            }
            el.dataset.tagularEvent = type;
            el.dataset.tagularUid = uid;
            el.dataset.tagularIndex = index + 1;
            store.dispatch({
                type: MAP_DATA,
                data: protobuf,
                uid: uid
            });
            store.dispatch({
                type: INCREMENT_UID
            });
            switch (eventType.toLowerCase()) {
                case 'scroll':
                case 'view':
                    observer(el, type, config);
                    break;

                case 'click':
                case 'contextmenu':
                case 'mousedown':
                case 'focus':
                case 'blur':
                case 'change':
                case 'touchcancel':
                case 'touchstart':
                case 'touchstop':
                case 'touchmove':
                    el.addEventListener(eventType, function(event) {
                        return setTimeout(function() {
                            return clickHandler(event, config);
                        }, 0);
                    });
                    break;

                default:
                    log$3('Event type not supported.', type, el);
            }
        });
    };
    var log$4 = debug$1('parse');
    var main = function main(error) {
        if (error) {
            log$4('Error', error);
        } else {
            log$4('Binding events to elements...');
            var _store$getState = store.getState(),
                sourceCache = _store$getState.sourceCache;
            forEach_1(sourceCache, function(value, key) {
                var elements = document.querySelectorAll(key);
                var protobuf = value.data ? value.data : value;
                var settings = value.settings ? value.settings : null;
                bind(elements, protobuf, settings);
            });
        }
    };
    var parse$1 = function(source) {
        var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!isPlainObject_1(source)) {
            log$4('Cannot process source data; it is not an Object.', source);
            return;
        }
        if (!reload) {
            store.dispatch({
                type: SOURCECACHE,
                source: source
            });
        }
        main();
    };
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        reIsPlainProp = /^\w*$/;
    function isKey(value, object) {
        if (isArray_1(value)) {
            return false;
        }
        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
            return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || (object != null && value in Object(object));
    }
    var _isKey = isKey;
    var FUNC_ERROR_TEXT = 'Expected a function';
    function memoize(func, resolver) {
        if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
            throw new TypeError(FUNC_ERROR_TEXT);
        }
        var memoized = function memoized() {
            var args = arguments,
                key = resolver ? resolver.apply(this, args) : args[0],
                cache = memoized.cache;
            if (cache.has(key)) {
                return cache.get(key);
            }
            var result = func.apply(this, args);
            memoized.cache = cache.set(key, result) || cache;
            return result;
        };
        memoized.cache = new (memoize.Cache || _MapCache)();
        return memoized;
    }
    memoize.Cache = _MapCache;
    var memoize_1 = memoize;
    var MAX_MEMOIZE_SIZE = 500;
    function memoizeCapped(func) {
        var result = memoize_1(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
                cache.clear();
            }
            return key;
        });
        var cache = result.cache;
        return result;
    }
    var _memoizeCapped = memoizeCapped;
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = _memoizeCapped(function(string) {
        var result = [];
        if (string.charCodeAt(0) === 46) {
            result.push('');
        }
        string.replace(rePropName, function(match, number, quote, subString) {
            result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
    });
    var _stringToPath = stringToPath;
    function castPath(value, object) {
        if (isArray_1(value)) {
            return value;
        }
        return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
    }
    var _castPath = castPath;
    var INFINITY$1 = 1 / 0;
    function toKey(value) {
        if (typeof value == 'string' || isSymbol_1(value)) {
            return value;
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
    }
    var _toKey = toKey;
    function baseGet(object, path) {
        path = _castPath(path, object);
        var index = 0,
            length = path.length;
        while (object != null && index < length) {
            object = object[_toKey(path[index++])];
        }
        return index && index == length ? object : undefined;
    }
    var _baseGet = baseGet;
    function get$1(object, path, defaultValue) {
        var result = object == null ? undefined : _baseGet(object, path);
        return result === undefined ? defaultValue : result;
    }
    var get_1 = get$1;
    var log$5 = debug$1('utils:callFn');
    var callFnByName = function callFnByName(fn) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
        var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        if (isUndefined_1(fn) || !isString_1(fn)) {
            throw new Error('A function name was not specified');
        }
        var namespaces = fn.split('.');
        var name = namespaces.pop();
        if (namespaces.length > 0) {
            context = get_1(context, namespaces.join('.'), context);
        }
        if (!isFunction_1(context[name])) {
            throw new Error('"' + context + '.' + name + '" is not a function');
        }
        var newFn = context[name];
        return newFn.apply(context, args);
    };
    var callFn = function(fn) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
        }
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var result = '';
        try {
            if (isFunction_1(fn)) {
                result = context ? fn.apply(context, args) : fn(args);
            } else if (isString_1(fn)) {
                result = callFnByName(fn, context, args);
            }
        } catch (err) {
            log$5('Error', fn, context, err);
            result = '';
        }
        return result;
    };
    var uuid = function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(char) {
            var rand = (Math.random() * 16) | 0;
            var val = char === 'x' ? rand : (rand & 3) | 8;
            return val.toString(16);
        });
    };
    var log$6 = debug$1('wildcard');
    var findForm = function findForm(element) {
        var form = element.closest('form');
        return form || element;
    };
    var wildcard = function(input) {
        var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
        var output = '';
        if (!isString_1(input)) {
            return input;
        }
        try {
            if (input.indexOf('data.') === 0) {
                output = el.dataset[input.replace('data.', '')] || input;
            } else if (input.indexOf('var.') === 0) {
                var _store$getState = store.getState(),
                    vars = _store$getState.vars;
                var variable = input.replace('var.', '');
                if (variable && variable in vars) {
                    output = vars[variable];
                } else {
                    log$6('Variable not found -- "' + input + '"');
                }
            } else if (input.indexOf('qs.') === 0) {
                output = getQueryString(input.replace('qs.', ''));
            } else if (input.indexOf('fn.') === 0) {
                output = callFn(input.replace('fn.', ''));
            } else {
                switch (input) {
                    case 'uuid':
                    case 'this.uuid':
                        output = uuid();
                        break;

                    case 'page.href':
                        output = window.location.href;
                        break;

                    case 'page.referrer':
                        output = document.referrer ? document.referrer : 'direct entry';
                        break;

                    case 'page.title':
                        output = document.title;
                        break;

                    case 'form.id':
                        output = findForm(el).getAttribute('id');
                        break;

                    case 'form.name':
                        output = findForm(el).getAttribute('name');
                        break;

                    case 'this.href':
                        output = el.href;
                        break;

                    case 'this.innerText':
                        output = el.innerText;
                        break;

                    case 'this.rel':
                        output = el.rel;
                        break;

                    case 'this.title':
                        output = el.title;
                        break;

                    case 'this.alt':
                        output = el.alt;
                        break;

                    case 'this.id':
                        output = el.id;
                        break;

                    case 'this.name':
                        output = el.name;
                        break;

                    case 'this.type':
                        output = el.type;
                        if (['text', 'email', 'tel', 'textarea'].indexOf(output) !== -1) {
                            output = 'enum';
                        }
                        break;

                    case 'this.value':
                        output = el.value;
                        break;

                    default:
                        output = input;
                }
            }
        } catch (err) {
            log$6('Error', input, el);
            output = '';
        }
        if (!output) {
            output = '';
        }
        return output;
    };
    var log$7 = debug$1('normalize');
    var strip = function strip(str) {
        return isString_1(str)
            ? str
                    .replace(/[^\x00-\x7F]+/gi, '')
                    .replace(/(\r\n|\n|\r)/gm, ' ')
                    .replace(/\s+/g, ' ')
                    .trim()
            : str;
    };
    var normalize = function normalize(data) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
        var out = {};
        try {
            Object.entries(data).forEach(function(_ref) {
                var _ref2 = slicedToArray(_ref, 2),
                    key = _ref2[0],
                    val = _ref2[1];
                if (key === '@type' && eventList[val]) {
                    out[key] = eventList[val].type;
                } else if (isFunction_1(val)) {
                    out[key] = strip(callFn(val, context));
                } else if (isString_1(val)) {
                    out[key] = strip(wildcard(val, context));
                } else if (isPlainObject_1(val)) {
                    out[key] = strip(normalize(val, context));
                } else if (Array.isArray(val)) {
                    out[key] = strip(val.join('|'));
                } else {
                    out[key] = strip(val);
                }
            });
        } catch (error) {
            log$7('Error when normalizing source data.', data);
            out = merge_1({}, data);
        }
        return out;
    };
    var log$8 = debug$1('track');
    var track = function(eventType, data, context) {
        var standardize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        log$8('Attempting to send Beam...');
        if (!isString_1(eventType) || !isPlainObject_1(data)) {
            log$8('Error: The event type or data is not valid! (eventType, data)', eventType, data);
            return;
        }
        var payload = standardize ? normalize(data, context) : data;
        try {
            window.tagular('beam', eventType, payload);
            log$8('Beam sent!');
            if (window.dataLayer) {
                window.dataLayer.push(
                    merge_1(
                        {
                            event: 'beam'
                        },
                        payload
                    )
                );
            }
        } catch (error) {
            log$8('Error', error);
        } finally {
            log$8(eventType, data);
        }
    };
    var log$9 = debug$1('init');
    var processQueue = function processQueue() {
        var _store$getState = store.getState(),
            queue = _store$getState.queue;
        if (queue && queue.length > 0) {
            var source = queue[0];
            parse$1(source);
            store.dispatch({
                type: DEQUEUE
            });
            processQueue();
        }
    };
    var triggerTrack = function triggerTrack(event) {
        var el = event.target.closest('[data-tagular-uid]');
        var uid = el.dataset.tagularUid;
        var type = el.dataset.tagularEvent;
        var state = store.getState();
        var data = state.data[uid];
        if (!type || !data) {
            log$9('Error in triggerTrack -> (type, data):', type, data);
            return;
        }
        track(type, data, el, true);
    };
    var setupEventListeners = function setupEventListeners() {
        window.removeEventListener(eventName, triggerTrack, true);
        window.addEventListener(eventName, triggerTrack, true);
    };
    var _init = function() {
        var _store$getState2 = store.getState(),
            initialized = _store$getState2.initialized;
        if (!initialized) {
            try {
                setupEventListeners();
                processQueue();
                store.dispatch({
                    type: INITIALIZE
                });
                log$9('Initialized.');
            } catch (error) {
                log$9('Error', error);
            }
        }
    };
    var vars = function(vars) {
        store.dispatch({
            type: ADD_VARS,
            vars: vars
        });
    };
    var bind$1 = function bind(fn, thisArg) {
        return function wrap() {
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; i++) {
                args[i] = arguments[i];
            }
            return fn.apply(thisArg, args);
        };
    };
    var isBuffer_1$1 = function isBuffer_1(obj) {
        return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
    };
    function isBuffer(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
    }
    function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
    }
    var toString$1 = Object.prototype.toString;
    function isArray$1(val) {
        return toString$1.call(val) === '[object Array]';
    }
    function isArrayBuffer(val) {
        return toString$1.call(val) === '[object ArrayBuffer]';
    }
    function isFormData(val) {
        return typeof FormData !== 'undefined' && val instanceof FormData;
    }
    function isArrayBufferView(val) {
        var result;
        if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
            result = ArrayBuffer.isView(val);
        } else {
            result = val && val.buffer && val.buffer instanceof ArrayBuffer;
        }
        return result;
    }
    function isString$1(val) {
        return typeof val === 'string';
    }
    function isNumber(val) {
        return typeof val === 'number';
    }
    function isUndefined$1(val) {
        return typeof val === 'undefined';
    }
    function isObject$1(val) {
        return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
    }
    function isDate(val) {
        return toString$1.call(val) === '[object Date]';
    }
    function isFile(val) {
        return toString$1.call(val) === '[object File]';
    }
    function isBlob(val) {
        return toString$1.call(val) === '[object Blob]';
    }
    function isFunction$1(val) {
        return toString$1.call(val) === '[object Function]';
    }
    function isStream(val) {
        return isObject$1(val) && isFunction$1(val.pipe);
    }
    function isURLSearchParams(val) {
        return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
    }
    function trim(str) {
        return str.replace(/^\s*/, '').replace(/\s*$/, '');
    }
    function isStandardBrowserEnv() {
        if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
            return false;
        }
        return typeof window !== 'undefined' && typeof document !== 'undefined';
    }
    function forEach$1(obj, fn) {
        if (obj === null || typeof obj === 'undefined') {
            return;
        }
        if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
            obj = [obj];
        }
        if (isArray$1(obj)) {
            for (var i = 0, l = obj.length; i < l; i++) {
                fn.call(null, obj[i], i, obj);
            }
        } else {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    fn.call(null, obj[key], key, obj);
                }
            }
        }
    }
    function merge$1() {
        var result = {};
        function assignValue(val, key) {
            if (_typeof(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
                result[key] = merge$1(result[key], val);
            } else {
                result[key] = val;
            }
        }
        for (var i = 0, l = arguments.length; i < l; i++) {
            forEach$1(arguments[i], assignValue);
        }
        return result;
    }
    function extend(a, b, thisArg) {
        forEach$1(b, function assignValue(val, key) {
            if (thisArg && typeof val === 'function') {
                a[key] = bind$1(val, thisArg);
            } else {
                a[key] = val;
            }
        });
        return a;
    }
    var utils = {
        isArray: isArray$1,
        isArrayBuffer: isArrayBuffer,
        isBuffer: isBuffer_1$1,
        isFormData: isFormData,
        isArrayBufferView: isArrayBufferView,
        isString: isString$1,
        isNumber: isNumber,
        isObject: isObject$1,
        isUndefined: isUndefined$1,
        isDate: isDate,
        isFile: isFile,
        isBlob: isBlob,
        isFunction: isFunction$1,
        isStream: isStream,
        isURLSearchParams: isURLSearchParams,
        isStandardBrowserEnv: isStandardBrowserEnv,
        forEach: forEach$1,
        merge: merge$1,
        extend: extend,
        trim: trim
    };
    var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
        utils.forEach(headers, function processHeader(value, name) {
            if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
                headers[normalizedName] = value;
                delete headers[name];
            }
        });
    };
    var enhanceError = function enhanceError(error, config, code, request, response) {
        error.config = config;
        if (code) {
            error.code = code;
        }
        error.request = request;
        error.response = response;
        return error;
    };
    var createError = function createError(message, config, code, request, response) {
        var error = new Error(message);
        return enhanceError(error, config, code, request, response);
    };
    var settle = function settle(resolve, reject, response) {
        var validateStatus = response.config.validateStatus;
        if (!response.status || !validateStatus || validateStatus(response.status)) {
            resolve(response);
        } else {
            reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
        }
    };
    function encode(val) {
        return encodeURIComponent(val)
            .replace(/%40/gi, '@')
            .replace(/%3A/gi, ':')
            .replace(/%24/g, '$')
            .replace(/%2C/gi, ',')
            .replace(/%20/g, '+')
            .replace(/%5B/gi, '[')
            .replace(/%5D/gi, ']');
    }
    var buildURL = function buildURL(url, params, paramsSerializer) {
        if (!params) {
            return url;
        }
        var serializedParams;
        if (paramsSerializer) {
            serializedParams = paramsSerializer(params);
        } else if (utils.isURLSearchParams(params)) {
            serializedParams = params.toString();
        } else {
            var parts = [];
            utils.forEach(params, function serialize(val, key) {
                if (val === null || typeof val === 'undefined') {
                    return;
                }
                if (utils.isArray(val)) {
                    key = key + '[]';
                } else {
                    val = [val];
                }
                utils.forEach(val, function parseValue(v) {
                    if (utils.isDate(v)) {
                        v = v.toISOString();
                    } else if (utils.isObject(v)) {
                        v = JSON.stringify(v);
                    }
                    parts.push(encode(key) + '=' + encode(v));
                });
            });
            serializedParams = parts.join('&');
        }
        if (serializedParams) {
            url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
        }
        return url;
    };
    var ignoreDuplicateOf = [
        'age',
        'authorization',
        'content-length',
        'content-type',
        'etag',
        'expires',
        'from',
        'host',
        'if-modified-since',
        'if-unmodified-since',
        'last-modified',
        'location',
        'max-forwards',
        'proxy-authorization',
        'referer',
        'retry-after',
        'user-agent'
    ];
    var parseHeaders = function parseHeaders(headers) {
        var parsed = {};
        var key;
        var val;
        var i;
        if (!headers) {
            return parsed;
        }
        utils.forEach(headers.split('\n'), function parser(line) {
            i = line.indexOf(':');
            key = utils.trim(line.substr(0, i)).toLowerCase();
            val = utils.trim(line.substr(i + 1));
            if (key) {
                if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
                    return;
                }
                if (key === 'set-cookie') {
                    parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
                } else {
                    parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
                }
            }
        });
        return parsed;
    };
    var isURLSameOrigin = utils.isStandardBrowserEnv()
        ? (function standardBrowserEnv() {
                var msie = /(msie|trident)/i.test(navigator.userAgent);
                var urlParsingNode = document.createElement('a');
                var originURL;
                function resolveURL(url) {
                    var href = url;
                    if (msie) {
                        urlParsingNode.setAttribute('href', href);
                        href = urlParsingNode.href;
                    }
                    urlParsingNode.setAttribute('href', href);
                    return {
                        href: urlParsingNode.href,
                        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
                        host: urlParsingNode.host,
                        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
                        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
                        hostname: urlParsingNode.hostname,
                        port: urlParsingNode.port,
                        pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
                    };
                }
                originURL = resolveURL(window.location.href);
                return function isURLSameOrigin(requestURL) {
                    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
                    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
                };
          })()
        : (function nonStandardBrowserEnv() {
                return function isURLSameOrigin() {
                    return true;
                };
          })();
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    function E() {
        this.message = 'String contains an invalid character';
    }
    E.prototype = new Error();
    E.prototype.code = 5;
    E.prototype.name = 'InvalidCharacterError';
    function btoa(input) {
        var str = String(input);
        var output = '';
        for (var block, charCode, idx = 0, map = chars; str.charAt(idx | 0) || ((map = '='), idx % 1); output += map.charAt(63 & (block >> (8 - (idx % 1) * 8)))) {
            charCode = str.charCodeAt((idx += 3 / 4));
            if (charCode > 255) {
                throw new E();
            }
            block = (block << 8) | charCode;
        }
        return output;
    }
    var btoa_1 = btoa;
    var cookies = utils.isStandardBrowserEnv()
        ? (function standardBrowserEnv() {
                return {
                    write: function write(name, value, expires, path, domain, secure) {
                        var cookie = [];
                        cookie.push(name + '=' + encodeURIComponent(value));
                        if (utils.isNumber(expires)) {
                            cookie.push('expires=' + new Date(expires).toGMTString());
                        }
                        if (utils.isString(path)) {
                            cookie.push('path=' + path);
                        }
                        if (utils.isString(domain)) {
                            cookie.push('domain=' + domain);
                        }
                        if (secure === true) {
                            cookie.push('secure');
                        }
                        document.cookie = cookie.join('; ');
                    },
                    read: function read(name) {
                        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
                        return match ? decodeURIComponent(match[3]) : null;
                    },
                    remove: function remove(name) {
                        this.write(name, '', Date.now() - 864e5);
                    }
                };
          })()
        : (function nonStandardBrowserEnv() {
                return {
                    write: function write() {},
                    read: function read() {
                        return null;
                    },
                    remove: function remove() {}
                };
          })();
    var btoa$1 = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || btoa_1;
    var xhr = function xhrAdapter(config) {
        return new Promise(function dispatchXhrRequest(resolve, reject) {
            var requestData = config.data;
            var requestHeaders = config.headers;
            if (utils.isFormData(requestData)) {
                delete requestHeaders['Content-Type'];
            }
            var request = new XMLHttpRequest();
            var loadEvent = 'onreadystatechange';
            var xDomain = false;
            if ('production' !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
                request = new window.XDomainRequest();
                loadEvent = 'onload';
                xDomain = true;
                request.onprogress = function handleProgress() {};
                request.ontimeout = function handleTimeout() {};
            }
            if (config.auth) {
                var username = config.auth.username || '';
                var password = config.auth.password || '';
                requestHeaders.Authorization = 'Basic ' + btoa$1(username + ':' + password);
            }
            request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
            request.timeout = config.timeout;
            request[loadEvent] = function handleLoad() {
                if (!request || (request.readyState !== 4 && !xDomain)) {
                    return;
                }
                if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
                    return;
                }
                var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
                var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
                var response = {
                    data: responseData,
                    status: request.status === 1223 ? 204 : request.status,
                    statusText: request.status === 1223 ? 'No Content' : request.statusText,
                    headers: responseHeaders,
                    config: config,
                    request: request
                };
                settle(resolve, reject, response);
                request = null;
            };
            request.onerror = function handleError() {
                reject(createError('Network Error', config, null, request));
                request = null;
            };
            request.ontimeout = function handleTimeout() {
                reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));
                request = null;
            };
            if (utils.isStandardBrowserEnv()) {
                var cookies$$1 = cookies;
                var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies$$1.read(config.xsrfCookieName) : undefined;
                if (xsrfValue) {
                    requestHeaders[config.xsrfHeaderName] = xsrfValue;
                }
            }
            if ('setRequestHeader' in request) {
                utils.forEach(requestHeaders, function setRequestHeader(val, key) {
                    if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
                        delete requestHeaders[key];
                    } else {
                        request.setRequestHeader(key, val);
                    }
                });
            }
            if (config.withCredentials) {
                request.withCredentials = true;
            }
            if (config.responseType) {
                try {
                    request.responseType = config.responseType;
                } catch (e) {
                    if (config.responseType !== 'json') {
                        throw e;
                    }
                }
            }
            if (typeof config.onDownloadProgress === 'function') {
                request.addEventListener('progress', config.onDownloadProgress);
            }
            if (typeof config.onUploadProgress === 'function' && request.upload) {
                request.upload.addEventListener('progress', config.onUploadProgress);
            }
            if (config.cancelToken) {
                config.cancelToken.promise.then(function onCanceled(cancel) {
                    if (!request) {
                        return;
                    }
                    request.abort();
                    reject(cancel);
                    request = null;
                });
            }
            if (requestData === undefined) {
                requestData = null;
            }
            request.send(requestData);
        });
    };
    var DEFAULT_CONTENT_TYPE = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    function setContentTypeIfUnset(headers, value) {
        if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
            headers['Content-Type'] = value;
        }
    }
    function getDefaultAdapter() {
        var adapter;
        if (typeof XMLHttpRequest !== 'undefined') {
            adapter = xhr;
        } else if (typeof process !== 'undefined') {
            adapter = xhr;
        }
        return adapter;
    }
    var defaults$3 = {
        adapter: getDefaultAdapter(),
        transformRequest: [
            function transformRequest(data, headers) {
                normalizeHeaderName(headers, 'Content-Type');
                if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
                    return data;
                }
                if (utils.isArrayBufferView(data)) {
                    return data.buffer;
                }
                if (utils.isURLSearchParams(data)) {
                    setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                    return data.toString();
                }
                if (utils.isObject(data)) {
                    setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                    return JSON.stringify(data);
                }
                return data;
            }
        ],
        transformResponse: [
            function transformResponse(data) {
                if (typeof data === 'string') {
                    try {
                        data = JSON.parse(data);
                    } catch (e) {}
                }
                return data;
            }
        ],
        timeout: 0,
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN',
        maxContentLength: -1,
        validateStatus: function validateStatus(status) {
            return status >= 200 && status < 300;
        }
    };
    defaults$3.headers = {
        common: {
            Accept: 'application/json, text/plain, */*'
        }
    };
    utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
        defaults$3.headers[method] = {};
    });
    utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
        defaults$3.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    var defaults_1 = defaults$3;
    function InterceptorManager() {
        this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected
        });
        return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
        if (this.handlers[id]) {
            this.handlers[id] = null;
        }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
        utils.forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) {
                fn(h);
            }
        });
    };
    var InterceptorManager_1 = InterceptorManager;
    var transformData = function transformData(data, headers, fns) {
        utils.forEach(fns, function transform(fn) {
            data = fn(data, headers);
        });
        return data;
    };
    var isCancel = function isCancel(value) {
        return !!(value && value.__CANCEL__);
    };
    var isAbsoluteURL = function isAbsoluteURL(url) {
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
    };
    var combineURLs = function combineURLs(baseURL, relativeURL) {
        return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
    };
    function throwIfCancellationRequested(config) {
        if (config.cancelToken) {
            config.cancelToken.throwIfRequested();
        }
    }
    var dispatchRequest = function dispatchRequest(config) {
        throwIfCancellationRequested(config);
        if (config.baseURL && !isAbsoluteURL(config.url)) {
            config.url = combineURLs(config.baseURL, config.url);
        }
        config.headers = config.headers || {};
        config.data = transformData(config.data, config.headers, config.transformRequest);
        config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
        utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
            delete config.headers[method];
        });
        var adapter = config.adapter || defaults_1.adapter;
        return adapter(config).then(
            function onAdapterResolution(response) {
                throwIfCancellationRequested(config);
                response.data = transformData(response.data, response.headers, config.transformResponse);
                return response;
            },
            function onAdapterRejection(reason) {
                if (!isCancel(reason)) {
                    throwIfCancellationRequested(config);
                    if (reason && reason.response) {
                        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
                    }
                }
                return Promise.reject(reason);
            }
        );
    };
    function Axios(instanceConfig) {
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new InterceptorManager_1(),
            response: new InterceptorManager_1()
        };
    }
    Axios.prototype.request = function request(config) {
        if (typeof config === 'string') {
            config = utils.merge(
                {
                    url: arguments[0]
                },
                arguments[1]
            );
        }
        config = utils.merge(
            defaults_1,
            {
                method: 'get'
            },
            this.defaults,
            config
        );
        config.method = config.method.toLowerCase();
        var chain = [dispatchRequest, undefined];
        var promise = Promise.resolve(config);
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            chain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            chain.push(interceptor.fulfilled, interceptor.rejected);
        });
        while (chain.length) {
            promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
    };
    utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
        Axios.prototype[method] = function(url, config) {
            return this.request(
                utils.merge(config || {}, {
                    method: method,
                    url: url
                })
            );
        };
    });
    utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
        Axios.prototype[method] = function(url, data, config) {
            return this.request(
                utils.merge(config || {}, {
                    method: method,
                    url: url,
                    data: data
                })
            );
        };
    });
    var Axios_1 = Axios;
    function Cancel(message) {
        this.message = message;
    }
    Cancel.prototype.toString = function toString() {
        return 'Cancel' + (this.message ? ': ' + this.message : '');
    };
    Cancel.prototype.__CANCEL__ = true;
    var Cancel_1 = Cancel;
    function CancelToken(executor) {
        if (typeof executor !== 'function') {
            throw new TypeError('executor must be a function.');
        }
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        executor(function cancel(message) {
            if (token.reason) {
                return;
            }
            token.reason = new Cancel_1(message);
            resolvePromise(token.reason);
        });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
        if (this.reason) {
            throw this.reason;
        }
    };
    CancelToken.source = function source() {
        var cancel;
        var token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    };
    var CancelToken_1 = CancelToken;
    var spread = function spread(callback) {
        return function wrap(arr) {
            return callback.apply(null, arr);
        };
    };
    function createInstance(defaultConfig) {
        var context = new Axios_1(defaultConfig);
        var instance = bind$1(Axios_1.prototype.request, context);
        utils.extend(instance, Axios_1.prototype, context);
        utils.extend(instance, context);
        return instance;
    }
    var axios = createInstance(defaults_1);
    axios.Axios = Axios_1;
    axios.create = function create(instanceConfig) {
        return createInstance(utils.merge(defaults_1, instanceConfig));
    };
    axios.Cancel = Cancel_1;
    axios.CancelToken = CancelToken_1;
    axios.isCancel = isCancel;
    axios.all = function all(promises) {
        return Promise.all(promises);
    };
    axios.spread = spread;
    var axios_1 = axios;
    var default_1 = axios;
    axios_1.default = default_1;
    var axios$1 = axios_1;
    var log$10 = debug$1('utils:request');
    var request = function(url, callback) {
        if (!isString_1(url)) {
            log$10('Cannot fetch URL. It is not a String.', url);
            return false;
        }
        return axios$1
            .get(url, {
                validateStatus: function validateStatus(status) {
                    return status >= 200 && status < 400;
                }
            })
            .catch(function(error) {
                log$10('There was an error processing: ' + url, error);
            })
            .then(function(_ref) {
                var data = _ref.data;
                callback(data);
            });
    };
    var log$11 = debug$1('setup');
    var setup = function(source) {
        if (isPlainObject_1(source) === false) {
            log$11('Cannot process source data; it is not an Object.', source);
            return;
        }
        var _store$getState = store.getState(),
            initialized = _store$getState.initialized;
        if (!initialized) {
            store.dispatch({
                type: ENQUEUE,
                source: source
            });
        } else {
            parse$1(source);
        }
    };
    var log$12 = debug$1('start');
    var start = function(source) {
        if (isString_1(source)) {
            request(source, setup);
        } else if (isPlainObject_1(source)) {
            setup(source);
        } else {
            log$12('Source is not a valid string or object.', source);
        }
    };
    var _load = function(source, variables, scriptPath) {
        if (!isString_1(source) && !isPlainObject_1(source)) {
            return;
        }
        if (variables) {
            if (isPlainObject_1(variables)) {
                vars(variables);
            } else if (isString_1(variables)) {
                store.dispatch({
                    type: SCRIPT_PATH,
                    path: variables
                });
            }
        }
        if (isString_1(scriptPath)) {
            store.dispatch({
                type: SCRIPT_PATH,
                path: scriptPath
            });
        }
        start(source);
    };
    var _reload = function() {
        var _store$getState = store.getState(),
            sourceCache = _store$getState.sourceCache;
        if (sourceCache) {
            parse$1(sourceCache, true);
        }
    };
    var name = 'beam';
    if (isFunction_1(window.cohesion)) {
        window.cohesion('ready', _init);
    }
    var beam = {
        init: function init() {
            _init.apply(undefined, arguments);
            return beam;
        },
        load: function load() {
            _load.apply(undefined, arguments);
            return beam;
        },
        reload: function reload() {
            _reload.apply(undefined, arguments);
            return beam;
        },
        track: function track$$1() {
            track.apply(undefined, arguments);
            return beam;
        },
        vars: function vars$$1() {
            vars.apply(undefined, arguments);
            return beam;
        }
    };
    window['_' + capitalize_1(name)] = beam;
    return beam;
})();



// WEBPACK FOOTER //
// ./assets/js/beam.js